import { render, staticRenderFns } from "./CustomFieldList.vue?vue&type=template&id=ba2d01fa&scoped=true&"
import script from "./CustomFieldList.vue?vue&type=script&lang=js&"
export * from "./CustomFieldList.vue?vue&type=script&lang=js&"
import style0 from "./CustomFieldList.vue?vue&type=style&index=0&id=ba2d01fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2d01fa",
  null
  
)

export default component.exports